import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Checkbox from "../UI/Form/Checkbox";
import LoneCheckbox from "../UI/LoneCheckbox/LoneCheckbox";
import useSet from "./useSet";
const DEFAULT_OPTIONS = {
    externallyCheckedItems: [],
};
export default function useCheckboxes(_options = {}) {
    const safeOptions = React.useMemo(() => (Object.assign(Object.assign({}, DEFAULT_OPTIONS), _options)), [_options]);
    const internalCheckedItems = useSet({
        equalsFunc: safeOptions.equalsFunc,
    });
    const touchedItems = useSet({
        equalsFunc: safeOptions.equalsFunc,
    });
    // Always use current version of equals function, don't cause re-renders when equal function changes.
    const equalsRef = React.useRef(safeOptions.equalsFunc);
    React.useEffect(() => {
        equalsRef.current = safeOptions.equalsFunc;
    }, [safeOptions]);
    const isChecked = React.useCallback((ids) => (Array.isArray(ids) ? ids : [ids]).every((id) => touchedItems.has(id)
        ? internalCheckedItems.has(id)
        : safeOptions.externallyCheckedItems.some((item) => 
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
        equalsRef.current(item, id))), [internalCheckedItems, safeOptions.externallyCheckedItems, touchedItems]);
    const checkStuff = React.useCallback((ids) => {
        internalCheckedItems.add(ids);
        touchedItems.add(ids);
    }, [internalCheckedItems, touchedItems]);
    const unCheckStuff = React.useCallback((ids) => {
        touchedItems.add(ids);
        internalCheckedItems.remove(ids);
    }, [internalCheckedItems, touchedItems]);
    const unCheckEverything = React.useCallback(() => {
        // Touch everything
        touchedItems.add(safeOptions.externallyCheckedItems);
        // Uncheck everything
        internalCheckedItems.clear();
    }, [internalCheckedItems, safeOptions.externallyCheckedItems, touchedItems]);
    const getCheckboxWithLabel = React.useCallback((id, props) => {
        return (_jsx(Checkbox, Object.assign({}, props, { checked: isChecked(id), onChange: () => {
                (isChecked(id) ? unCheckStuff : checkStuff)(Array.isArray(id) ? id : [id]);
            } })));
    }, [checkStuff, isChecked, unCheckStuff]);
    const getCheckbox = React.useCallback((id, props) => {
        return (_jsx(LoneCheckbox, Object.assign({}, props, { checked: isChecked(id), onChange: () => {
                (isChecked(id) ? unCheckStuff : checkStuff)(Array.isArray(id) ? id : [id]);
            } })));
    }, [checkStuff, isChecked, unCheckStuff]);
    // @ts-expect-error - TS2322 - Type '{ checkedItems: T[]; checkStuff: (ids: T[]) => void; getCheckbox: (id: T | T[], props?: any) => JSX.Element; getCheckboxWithLabel: (id: T | T[], props: Flow.Diff<CheckboxProps, { ...; }>) => JSX.Element; unCheckStuff: (ids: T[]) => void; unCheckEverything: () => void; isChecked: (ids: T | T[]) => boolean; }' is not assignable to type 'useCheckboxesReturn<T>'.
    return React.useMemo(() => ({
        checkedItems: internalCheckedItems.values.concat(safeOptions.externallyCheckedItems.filter((item) => !touchedItems.has(item))),
        checkStuff,
        getCheckbox,
        getCheckboxWithLabel,
        unCheckStuff,
        unCheckEverything,
        isChecked,
    }), [
        internalCheckedItems.values,
        safeOptions.externallyCheckedItems,
        checkStuff,
        getCheckbox,
        getCheckboxWithLabel,
        unCheckStuff,
        unCheckEverything,
        isChecked,
        touchedItems,
    ]);
}
